
<div class="row">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator" ></ngx-loading>
        <!-- START OF SEARCH PANEL -->
        <div class="row mb-1 pt-0">
            <div class="col">
                <div class="form-group form-group-sm">
                    <div class="input-group input-group-sm box-shadow">
                        <div class="input-group-prepend">
                            <div class="input-group-text border-top-0 border-left-0 border-bottom-0 rounded-0"><i class="fa fa-search"></i></div>
                        </div>                        
                        <input type="text" [(ngModel)]="searchText" placeholder="Search super administrator user by name..."  class="form-control border-0 input-sm">
                        <div class="input-group-append">
                            <span (click)="openAddModal(modalAddUser)" class="input-group-text border-top-0 border-right-0 border-bottom-0"><i class="fa fa-user-plus"></i></span>&nbsp;
                            <span (click)="toggle('grid')" class="input-group-text border-top-0 border-right-0 border-bottom-0"><i class="fa fa-th"></i></span>
                            <span (click)="toggle('list')" class="input-group-text border-top-0 border-right-0 border-bottom-0 rounded-0"><i class="fa fa-list"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END OF SEARCH PANEL -->

        <!-- START OF GRID TABLE -->
        <div *ngIf="type=='grid'" class="row pt-0">
            <div *ngFor="let member of members | MemberSearchPipe : searchText | paginate: { itemsPerPage: 12, currentPage: p }; let i = index;" class="col-xl-4 col-lg-6 mb-4">
                <div class="flip">
                    <div class="content">
                        <div class="front">
                            <div class="card border-0 box-shadow rounded-0">
                                <div class="card-header border-0 rounded-0 text-muted">
                                    <h5 class="mb-0">
                                        {{member.display_name}}
                                    </h5>
                                    <div class="widget-controls"> 
                                        <a (click)="openModal(modalContent, member)" href="javascript:void(0);" class="transition"><i class="fa fa-pencil"></i></a>             
                                        <a (click)="openModalChangePassword(modalPassword, member.id)" href="javascript:void(0);" class="transition"><i class="fa fa-key"></i></a> 
                                        
                                        <a *ngIf="member.status == 0" (click)="changeStatus(modalStatus, member)"  title="Activate" href="javascript:void(0);" class="transition">
                                            <i class="fa fa-user-o"></i></a>
                                        <a *ngIf="member.status == 1" (click)="changeStatus(modalStatus, member)" title="Deactivate" href="javascript:void(0);" class="transition"><i class="fa fa-user-times"></i></a>

                                        <a (click)="openDeleteAdminModal(member)" href="javascript:void(0);" class="transition"><i class="fa fa-trash"></i></a> 
                                    </div>     
                                </div>
                                <div class="card-body pt-3">
                                    <div class="media">
                                        <div class="d-flex flex-column justify-content-center">
                                            <img *ngIf="member.avatar == '' || member.avatar == 'nopic.png' || member.avatar == null" class="rounded-circle" src="assets/img/users/default-user.jpg" width="80" height="80">
                                            <img *ngIf="member.avatar != '' && member.avatar != 'nopic.png' && member.avatar != null" class="rounded-circle" src="{{folderPath}}/{{member.avatar}}" width="80" height="80">
                                        </div>                    
                                        <div class="media-body ml-3">
                                            <div class="row">  
                                                <div class="col-4 text-gray text-right pr-0 font-italic text-truncate">username:</div>
                                                <div class="col-8 pl-2 text-truncate">{{member.username}}</div>
                                                <div class="col-4 text-gray text-right pr-0 font-italic text-truncate">email:</div>
                                                <div class="col-8 pl-2 text-truncate">{{member.email}}</div>
                                                <div class="col-4 text-gray text-right pr-0 font-italic text-truncate">joined:</div>
                                                <div class="col-8 pl-2 text-truncate fs-12 pt-2p">{{member.joined | date:"dd MMMM yyyy"}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END OF GRID TABLE -->

        <!-- START OF LIST TABLE -->
        <div *ngIf="type=='list'" class="row pt-0">
            <div class="col-12">
                <div class="table-responsive bg-white box-shadow">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Full Name</th> 
                                <th>Username</th>
                                <th>Email</th>
                                <th>Joined</th>                        
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let member of members |  MemberSearchPipe : searchText | paginate: { itemsPerPage: 10, currentPage: p }">                        
                                <td class="align-middle text-truncate">{{member.display_name}}</td>
                                <td class="align-middle text-truncate">{{member.username}}</td>
                                <td class="align-middle text-truncate">{{member.email}}</td>
                                <td class="align-middle text-truncate">{{member.joined | date:"dd MMMM yyyy"}}</td>
                                <td class="align-middle">
                                    <div class="btn-group" role="group">
                                        <button class="btn btn-secondary btn-sm" (click)="openModal(modalContent, member)"><i class="fa fa-pencil"></i></button>
                                        <button class="btn btn-secondary btn-sm" (click)="openModalChangePassword(modalPassword, member.id)"><i class="fa fa-key"></i></button>
                                        <button *ngIf="member.status == 0" class="btn btn-secondary btn-sm" (click)="changeStatus(modalStatus, member)"><i class="fa fa-user-o"></i></button>
                                        <button *ngIf="member.status == 1" class="btn btn-secondary btn-sm" (click)="changeStatus(modalStatus, member)"><i class="fa fa-user-times"></i></button>
                                        <button class="btn btn-secondary btn-sm" (click)="openDeleteAdminModal(member)"><i class="fa fa-trash"></i></button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- END OF LIST TABLE -->

        <!-- START OF PAGINATION -->
        <div class="row">
            <div class="col-12">
                <div class="bg-white text-center">
                    <pagination-controls autoHide="true" (pageChange)="p = $event" maxSize="10"></pagination-controls>
                </div>        
            </div>
        </div>
        <!-- END OF PAGINATION -->
    </div>
</div>


<!-- START OF ADD MODAL FORM -->
<ng-template #modalAddUser>
    <div class="modal-header">
        <h4 class="modal-title">Add New Super Administrator Account</h4>
        <button type="button" class="close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addForm" (ngSubmit)="onSubmitAddForm(addForm.value)" enctype="multipart/form-data" method="post">
    <div class="modal-body">
        <div class="row">           
            <div class="col-12">
                <div class="form-group" *ngIf ="(picExists==true)">
                    <label class="text-gray">Avatar</label><br/>
                    <img *ngIf="(addForm.get('avatar').value != '' && addForm.get('avatar').value != 'nopic.png')" src="{{folderPath}}/{{addForm.get('avatar').value}}" width="80">
                    <button class="btn btn-primary" type="button" (click)="removePic()">Remove Image</button>
                </div>
                
                <div class="form-group" *ngIf ="(picExists==false)">
                    <label class="text-gray">Avatar</label>
                        <app-image-uploader (passImage)="getFile($event, addForm)"></app-image-uploader>
                </div>                                                            
                <div class="form-group">
                    <label class="form-control-label">Username<span class="text-danger">*</span></label>
                    <input formControlName="username" class="form-control form-control-sm validation-field" type="text" (change)="checkUniqueUsername('add')" 
                    [ngClass]="{'form-control-danger' :  (addForm.get('username').hasError('required') || addForm.get('username').hasError('minLenght') || addForm.get('username').hasError('notUnique')), 'form-control-success' :  (!addForm.get('username').hasError('required') && !addForm.get('username').hasError('minLenght') && !addForm.get('username').hasError('notUnique')) }" NgbAutoFocus>
                    <small class="text-danger" *ngIf="addForm.controls.username.touched && addForm.controls.username.errors?.required">Username is required</small>                              
                    <small class="text-danger" *ngIf="addForm.controls.username.touched && addForm.controls.username.errors?.minlength">Username isn't long enough, minimum of {{ addForm.controls.username.errors.minlength.requiredLength}} characters</small>
                    <small class="text-danger" *ngIf="addForm.controls.username.touched &&!is_unique">Enter another username, this one already exists.</small>

                </div>
                <div class="form-group">
                    <label class="form-control-label">New Password <span class="text-danger">*</span></label>
                    <input class="form-control form-control-sm" type="password" formControlName="password" required>
                    <div *ngIf="addForm.controls.password.touched">
                        <div *ngIf="addForm.controls.password.errors?.required">
                            <small class="text-danger">This field is required.</small>
                        </div>
                        <div *ngIf="addForm.controls.password.errors?.minlength">
                            <small class="text-danger">New Password should be maximum {{addForm.controls.password.errors.minlength.requiredLength}} numeric values only.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-control-label">Verify Password <span class="text-danger">*</span></label>
                    <input class="form-control form-control-sm" type="password" formControlName="confirm_password" required><br />
                    <div *ngIf="addForm.controls.confirm_password.touched">
                        <div *ngIf="addForm.controls.confirm_password.errors?.required">
                            <small class="text-danger">This field is required.</small>
                        </div>
                        <div  *ngIf="addForm.hasError('notSame')">
                            <small class="text-danger">Password confirmation does not match.</small>
                        </div>
                    </div>

                </div>
                <div class="form-group">
                    <label class="form-control-label">Display Name<span class="text-danger">*</span></label>
                    <input formControlName="display_name" class="form-control form-control-sm validation-field" type="text">
                    <small class="text-danger" *ngIf="addForm.controls.display_name.touched && addForm.controls.display_name.errors?.required">Full name is required</small>     
                    <small class="text-danger" *ngIf="addForm.controls.display_name.touched && addForm.controls.display_name.errors?.minlength">Full name isn't long enough, minimum of {{addForm.controls.display_name.errors.minlength.requiredLength}} characters</small>                         
                </div>
                    <div class="form-group">
                    <label class="form-control-label">Email<span class="text-danger">*</span></label>
                    <input formControlName="email" class="form-control form-control-sm validation-field" type="email">
                    <small class="text-danger" *ngIf="addForm.controls.email.touched && addForm.controls.email.errors?.required">Email is required</small>                              
                    <small class="text-danger" *ngIf="addForm.controls.email.touched && addForm.controls.email.errors?.pattern">Email must be a valid email address.</small>
                </div>
            </div>
        </div>    
    </div>

    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button [disabled]="!addForm.valid || !is_unique || spinner == true" class="btn btn-sm btn-success mr-2" type="submit">
            <span>Save</span>
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div> 
</form> 
</ng-template>
<!-- END OF ADD MODAL FORM -->




<!-- START OF MODAL FORM -->
<ng-template #modalContent>
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="member.id">Update Super Administrator Account</h4>
        <button type="button" class="close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
<form [formGroup]="form1" (ngSubmit)="onSubmit(form1.value)" enctype="multipart/form-data" method="post">
    <div class="modal-body">
        <div class="row">           
            <div class="col-12">
                <div class="form-group" *ngIf ="(picExists==true)">
                    <label class="text-gray">Avatar</label><br/>
                    <img *ngIf="(form1.get('avatar').value != '' && form1.get('avatar').value != 'nopic.png')" src="{{folderPath}}/{{form1.get('avatar').value}}" width="80">
                    <button class="btn btn-primary" type="button" (click)="removePic()">Remove Image</button>
                </div>
                
                <div class="form-group" *ngIf ="(picExists==false)">
                    <label class="text-gray">Avatar</label>
                        <app-image-uploader (passImage)="getFile($event, form1)"></app-image-uploader>
                </div>                                                         
                <div class="form-group">
                    <label class="form-control-label">Display Name<span class="text-danger">*</span></label>
                    <input formControlName="display_name" class="form-control form-control-sm validation-field" type="text">
                    <small class="text-danger" *ngIf="form1.controls.display_name.touched && form1.controls.display_name.errors?.required">Full name is required</small>     
                    <small class="text-danger" *ngIf="form1.controls.display_name.touched && form1.controls.display_name.errors?.minlength">Full name isn't long enough, minimum of {{form1.controls.display_name.errors.minlength.requiredLength}} characters</small>                         
                </div>
                    <div class="form-group">
                    <label class="form-control-label">Username<span class="text-danger">*</span></label>
                    <input formControlName="username" class="form-control form-control-sm validation-field" type="text" (change)="checkUniqueUsername('update')">
                    <small class="text-danger" *ngIf="form1.controls.username.touched && form1.controls.username.errors?.required">Username is required</small>                              
                    <small class="text-danger" *ngIf="form1.controls.username.touched && form1.controls.username.errors?.minlength">Username isn't long enough, minimum of {{ form1.controls.username.errors.minlength.requiredLength}} characters</small>
                    <small class="text-danger" *ngIf="form1.controls.username.touched &&!is_unique">Enter another username, this one already exists.</small>
                </div>
                    <div class="form-group">
                    <label class="form-control-label">Email<span class="text-danger">*</span></label>
                    <input formControlName="email" class="form-control form-control-sm validation-field" type="email">
                    <small class="text-danger" *ngIf="form1.controls.email.touched && form1.controls.email.errors?.required">Email is required</small>                              
                    <small class="text-danger" *ngIf="form1.controls.email.touched && form1.controls.email.errors?.pattern">Email must be a valid email address.</small>
                </div>
            </div>
        </div>    
    </div>

    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button [disabled]="!form1.dirty || !form1.valid || spinner == true || !is_unique" class="btn btn-sm btn-success mr-2" type="submit">
            <span *ngIf="!member.id">Save</span>
            <span *ngIf="member.id">Save Changes</span>
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div> 
</form> 
</ng-template>
<!-- END OF MODAL FORM -->

<!--- START OF CHANGE PASSWORD MODAL -->
<ng-template #modalPassword>
    <div class="modal-header">
        <h4 class="modal-title">Change Super Administrator Password</h4>
        <button type="button" class="close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
<form [formGroup]="frmPassword" (ngSubmit)="updatePassword(frmPassword.value)">
    <div class="modal-body">
        <div class="row"> 
            <div class="form-group col-md-12">
                <label class="form-control-label">New Password <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="password" formControlName="new_password" required NgbAutoFocus>
                <div *ngIf="frmPassword.controls.new_password.touched">
                    <div *ngIf="frmPassword.controls.new_password.errors?.required">
                        <small class="text-danger">This field is required.</small>
                    </div>
                    <div *ngIf="frmPassword.controls.new_password.errors?.minlength">
                        <small class="text-danger">New Password should be maximum {{frmPassword.controls.new_password.errors.minlength.requiredLength}} numeric values only.</small>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-12">
                <label class="form-control-label">Verify Password <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="password" formControlName="confirm_password" required>
                <div *ngIf="frmPassword.controls.confirm_password.touched">
                    <div *ngIf="frmPassword.controls.confirm_password.errors?.required">
                        <small class="text-danger">This field is required.</small>
                    </div>
                    <div  *ngIf="frmPassword.hasError('notSame')">
                        <small class="text-danger">Password confirmation does not match.</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button [disabled]="!frmPassword.valid || spinner == true" type="button" class="btn btn-sm btn-success" type="submit">Save Changes</button>&nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</form>
</ng-template>
<!-- END OF CHANGE PASSWORD MODAL -->

<!--- START OF CHANGE STATUS MODAL -->
<ng-template #modalStatus let-close="close">
    <div *ngFor='let sel of selected'>
        <div *ngIf="sel.id == user.id">
    <div class="modal-header">
        <h5 class="modal-title">Change Super Administrator Status - {{sel.display_name}}</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
               Are you sure to {{ (sel.status == 0) ? 'activate' : 'deactivate'}} this user?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="(sel.status == 0)" type="button" class="btn btn-sm btn-success" (click)="editMemberStatus(sel.id, 1)" [disabled]="spinner == true">
            Activate</button>
        <button *ngIf="(sel.status == 1)" type="button" class="btn btn-sm btn-danger" (click)="editMemberStatus(sel.id, 0)" [disabled]="spinner == true">
            Deactivate</button>
        <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="closeModal()">Cancel</button>
    </div></div></div>
</ng-template>
<!-- END OF CHANGE STATUS MODAL -->

<!-- DELETE SUPER ADMIN ACCOUNT -->
<ng-template #modalDeleteSuperAdmin>
    <div class="modal-header">
        <h5 class="modal-title">Delete Super Administrator Account</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <h6 class="text-danger">{{this.memberDelete.display_name | uppercase}}</h6>
                <p>This account will be deleted permanently. Are you sure to proceed?</p>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="deleteMember()" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary " (click)="closeModal()">Cancel</button>
    </div>
</ng-template>
<!-- END OF DELETE SUPER ADMIN ACCOUNT -->

